import { render, staticRenderFns } from "./UsersTableHead.vue?vue&type=template&id=d8b52404&scoped=true&"
import script from "./UsersTableHead.vue?vue&type=script&lang=js&"
export * from "./UsersTableHead.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableHead.vue?vue&type=style&index=0&id=d8b52404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b52404",
  null
  
)

export default component.exports